import { Component,Input } from '@angular/core';
import { Subject } from 'rxjs';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ErrorMsgHandler } from 'src/app/shared/errormanagement/handleerror';
import { WidgetBuilderVarService } from '../widget-builder-service/widget-builder-var.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';



@Component({
  selector: 'app-chart-label',
  templateUrl: './chart-label.component.html',
  styleUrls: ['./chart-label.component.scss']
})
export class ChartLabelComponent {
  public _data:any = {};

  bgColor={"background-color":"#fff9eb","color": "#8f1500"}
  @Input() mode:string;
  @Input() widgetId:string;
  @Input() widgetInfo:any = {};
  @Input()
  set data(value:any){
    if(value !== this._data) {
      this._data = value
      // console.log("input data changed ==",this._data)
      if(Object.keys(this._data).length){

        this.setWidgetData()
        this.isProgress = false
      }
    }
  }
 
  get data():any{
    return this._data;
  }

  isProgress:boolean = true;
  title:string = "";
  labelData:any;

  handledashboardwidgetnodata = new ErrorMsgHandler()
  errorhandledashboardwidget = new ErrorMsgHandler()

  constructor(public dashboardService : DashboardService,
    public widgetbuildervarservice :WidgetBuilderVarService
  ) {}

  private destroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    if(this.mode === "preview"){
      this.isProgress = false
    }
     if(Object.keys(this._data).length){
      this.setWidgetData()
      
    }
//console.log("Mode =---->",this.mode)

    this.widgetbuildervarservice.previewProgress$.pipe(takeUntil(this.destroy$))
    .subscribe((val)=>{

      if(val){
        this.isProgress = true
      } else {
        this.isProgress = false
      }
    })
  }

  ngAfterViewInit(){
    this.widgetbuildervarservice.previewColorpalette$.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe((val:any) => {

      if(val.length){
      this.bgColor['background-color']=val[1]
      this.bgColor.color=val[8]

//console.log("BG2 ->",this.bgColor)
      }
      
    })
  }


  setWidgetData(){

    if(this._data?.style?.color_palette?.length){

//console.log("BG COLOR CHANGE")
//console.log(this._data?.style?.color_palette)
      this.bgColor['background-color']=this._data?.style?.color_palette[1]
      this.bgColor.color=this._data?.style?.color_palette[8]
//console.log("BG1 =---->",this.bgColor)
      
    }

    this.errorhandledashboardwidget.resetError()
    if(this.mode == "builder") {
      this.title = this._data["title"]
//console.log(this.title,"=============title")
      if(this._data.hasOwnProperty("error")){
          this.errorhandledashboardwidget.seterror(true, this._data.error?.errmsg);        
      } 
      else {
        if(!this._data["widgetdata"]?.rows?.length){
          this.labelData = 0
        } else {
          this.labelData = this._data?.widgetdata?.rows?.[0]?.metric1
        } 
      }  
    }else if(this.mode == "preview"){
      this.title = this._data["title"]
//console.log(this.title,"=============title")
      if(this._data.hasOwnProperty("error")){
          this.errorhandledashboardwidget.seterror(true, this._data.error?.errmsg);        
      } 
      else {
        if(!this._data["widgetdata"]?.rows?.length){
          this.labelData = 0
        } else {
          this.labelData = this._data?.widgetdata?.rows?.[0]?.metric1
        } 
      } 
    }

//console.log("BG color =---->",this.bgColor)
  }

  getFormattedValue(input: string, chart_type?: string): string {
    const num = Number(input);
  
    // handle invalid numbers
    if (isNaN(num)) {
      return input;
    }
  
    const formatter = this.dashboardService.getFormaterFunction(chart_type);
    return formatter(num);
  }

  getFormattedSize(input: string): string {
    const num = Number(input);
  
    // handle invalid or negative values
    if (isNaN(num) || num < 0) {
      return input;
    }
  
    const formatter = this.dashboardService.getFormaterSize();
    return formatter(num);
  }

  ngOnDestroy(){
    this.destroy$.next()
    this.destroy$.complete()
  }
}
